export const emailConfirmation = {
  error: 'Erro na confirmação do email. Por favor, tente novamente.'
}
